<div class="admin-members-table-container">
  @if (isLoaderActive) {
    <div class="admin-member__list-loader">
      <div class="admin-member__list-loader-inner">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    </div>
  }

  @if (members?.length) {
    <div class="members-list" [class.has-pagination]="paginationLength > 1">
      <div class="members-list__container">
        <table class="members-list__main" tabindex="0" [attr.aria-label]="'translations.global.ariaLabels.usersList' | transloco">
          <thead class="members-list__header">
            <tr>
              @if (isColumnEnabled('SELECT')) {
                <th class="checkbox-cell header-align" [class.expanded]="expanded" id="header-select" scope="col">
                  <mat-checkbox
                    [(ngModel)]="allUsersChecked"
                    [tabIndex]="0"
                    color="primary"
                    [attr.aria-label]="
                      allUsersChecked
                        ? ('translations.global.ariaLabels.uncheckAllUsers' | transloco)
                        : ('translations.global.ariaLabels.checkAllUsers' | transloco)
                    "
                    (change)="onAllCheckboxChange()"
                    class="members-list__checkbox"
                  >
                    <span class="cdk-visually-hidden">{{
                      allUsersChecked
                        ? ('translations.global.ariaLabels.uncheckAllUsers' | transloco)
                        : ('translations.global.ariaLabels.checkAllUsers' | transloco)
                    }}</span>
                  </mat-checkbox>
                </th>
              }

              @if (isColumnEnabled('EXTERNAL_ID')) {
                <th
                  class="external-id header-align"
                  id="header-external-id"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.id' | transloco"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.id' | transloco }}</span>
                  </div>
                </th>
              }

              @if (isColumnEnabled('FIRST_NAME')) {
                <th
                  id="header-first-name"
                  scope="col"
                  class="first-name header-align pointer"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByFirstName' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('firstName')"
                  (click)="changeListOrdering('firstName')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.firstName' | transloco }}</span>
                    @if (defaultOrderBy === 'firstName') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'firstName' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'firstName')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isColumnEnabled('LAST_NAME')) {
                <th
                  id="header-last-name"
                  scope="col"
                  class="last-name header-align sticky-columns-right-border pointer"
                  [class.expanded]="expanded"
                  [tabIndex]="0"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByLastName' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('lastName')"
                  (click)="changeListOrdering('lastName')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.lastName' | transloco }}</span>
                    @if (defaultOrderBy === 'lastName') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'lastName' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'lastName')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isColumnEnabled('EMAIL')) {
                <th
                  id="header-email"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.email' | transloco"
                >
                  <span class="column-name body-s">{{ 'translations.global.label.email' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('WILL_ATTEND')) {
                <th
                  id="header-will-attend"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.label.registered' | transloco"
                  (click)="changeListOrdering('enrollment.registeredOn')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.registered' | transloco }}</span>
                    @if (defaultOrderBy === 'enrollment.registeredOn') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'enrollment.registeredOn' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'enrollment.registeredOn')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              <!-- class role-cell for height update -->
              @if (isColumnEnabled('ROLES') && !isEvent) {
                <th
                  id="header-roles"
                  scope="col"
                  class="role-cell"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.role' | transloco"
                >
                  <span class="column-name body-s">{{ 'translations.global.label.role' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('STATUS')) {
                <th
                  class="pointer"
                  id="header-status"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByStatus' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering(isCardPage ? 'cardStatus' : 'playlistStatus')"
                  (click)="changeListOrdering(isCardPage ? 'cardStatus' : 'playlistStatus')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.status' | transloco }}</span>
                    @if (defaultOrderBy === 'cardStatus' || defaultOrderBy === 'playlistStatus') {
                      <i class="material-icons" aria-hidden="true">
                        {{
                          (defaultOrderBy === 'cardStatus' || defaultOrderBy === 'playlistStatus') && order === 'ASC'
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'
                        }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'cardStatus' || defaultOrderBy === 'playlistStatus')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }

              @if (isColumnEnabled('ENROL') && (playlistHastTicketsRegistration$ | async)) {
                <th
                  class="pointer"
                  id="header-enrol"
                  scope="col"
                  [class.expanded]="expanded"
                  tabindex="0"
                  role="button"
                  (click)="changeListOrdering('enrollment.registeredOn')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.registered' | transloco }}</span>
                    @if (defaultOrderBy === 'enrollment.registeredOn') {
                      <i class="material-icons" aria-hidden="true">
                        {{
                          (defaultOrderBy === 'cardStatus' || defaultOrderBy === 'enrollment.registeredOn') && order === 'ASC'
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'
                        }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'enrollment.registeredOn')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }

              @if (isColumnEnabled('REVIEW_STATUS')) {
                <th class="pointer" id="header-review-status" scope="col" [class.expanded]="expanded" tabindex="0" role="button">
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.reviewStatus' | transloco }}</span>
                  </div>
                </th>
              }

              @if (isColumnEnabled('STARTED')) {
                <th
                  class="pointer"
                  id="header-started"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByStartedOn' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('startedOn')"
                  (click)="changeListOrdering('startedOn')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.started' | transloco }}</span>
                    @if (defaultOrderBy === 'startedOn') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'startedOn' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'startedOn')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isColumnEnabled('COMPLETED')) {
                <th
                  class="pointer"
                  id="header-completed"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByCompletedOn' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('completedOn')"
                  (click)="changeListOrdering('completedOn')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.completed' | transloco }}</span>
                    @if (defaultOrderBy === 'completedOn') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'completedOn' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'completedOn')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isColumnEnabled('LAST_ACTIVE')) {
                <th
                  class="pointer"
                  id="header-last-active"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByLastActiveOn' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('lastActiveOn')"
                  (click)="changeListOrdering('lastActiveOn')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name body-s">{{ 'translations.global.label.lastActive' | transloco }}</span>
                    @if (defaultOrderBy === 'lastActiveOn') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'lastActiveOn' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'lastActiveOn')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isPlaylistPage) {
                @for (card of members[0].cards; track card; let j = $index) {
                  <th [class.expanded]="expanded">
                    <span class="body-s max-two-lines" [title]="card.header" [attr.aria-label]="card.header">
                      {{ card.header }}
                    </span>
                  </th>
                }
              }
              @if (isColumnEnabled('JOIN_DATE')) {
                <th
                  class="pointer"
                  id="header-join-date"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.orderByJoinDate' | transloco"
                  tabindex="0"
                  role="button"
                  (keydown.enter)="changeListOrdering('createdAt')"
                  (click)="changeListOrdering('createdAt')"
                >
                  <div class="header-title-icon-box">
                    <span class="column-name small bold">{{ 'translations.global.label.joinDate' | transloco }}</span>
                    @if (defaultOrderBy === 'createdAt') {
                      <i class="material-icons" aria-hidden="true">
                        {{ defaultOrderBy === 'createdAt' && order === 'ASC' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    }
                    @if (!(defaultOrderBy === 'createdAt')) {
                      <i class="material-icons small-icon" aria-hidden="true">unfold_more</i>
                    }
                  </div>
                </th>
              }
              @if (isColumnEnabled('RESPONSE_DATE')) {
                <th
                  id="header-response-date"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.label.responseDate' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.responseDate' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('HAS_ATTENDED')) {
                <th
                  id="header-has-attended"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.label.hasAttended' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.hasAttended' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('CHECK_IN_METHOD')) {
                <th
                  [class.expanded]="expanded"
                  id="header-check-in-method"
                  scope="col"
                  [attr.aria-label]="'translations.global.label.checkInMethod' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.checkInMethod' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('CHECK_IN_TIME')) {
                <th
                  id="header-check-in-time"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.label.checkInTime' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.checkInTime' | transloco }}</span>
                </th>
              }
              <!-- class role-cell for height update -->
              @if (isColumnEnabled('ROLES') && isEvent) {
                <th
                  class="role-cell"
                  id="header-roles-in-event"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.role' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.role' | transloco }}</span>
                </th>
              }
              @if (isColumnEnabled('GROUPS')) {
                <th
                  id="header-groups"
                  scope="col"
                  [class.expanded]="expanded"
                  [attr.aria-label]="'translations.global.ariaLabels.group' | transloco"
                >
                  <span class="column-name small bold">{{ 'translations.global.label.group' | transloco }}</span>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (member of members; track member._id; let i = $index) {
              <tr
                #memberRow
                class="item-row"
                tabindex="0"
                role="button"
                (mouseover)="setHoveredMember(member._id)"
                (mouseleave)="resetHoveredMember()"
                (focus)="setHoveredMember(member._id)"
                [class.is-hovered]="hoveredUserUid === member._id"
                [class.is-highlighted]="member._id === highlightedMemberId"
                [attr.aria-label]="
                  'translations.global.ariaLabels.openUserRecord' | transloco: { title: member.firstName + ' ' + member.lastName }
                "
                (keydown.enter)="openUserRecordByUid(member)"
                (click)="openUserRecordByUid(member)"
              >
                @if (isColumnEnabled('SELECT')) {
                  <td class="checkbox-cell" [headers]="'header-select'" [class.expanded]="expanded">
                    <mat-checkbox
                      [tabIndex]="0"
                      color="primary"
                      [checked]="member.checked"
                      [attr.aria-label]="
                        member.checked
                          ? ('translations.global.ariaLabels.uncheck' | transloco: { name: member.firstName + ' ' + member.lastName })
                          : ('translations.global.ariaLabels.check' | transloco: { name: member.firstName + ' ' + member.lastName })
                      "
                      (change)="onCheckboxChange(member._id)"
                      (click)="$event.stopPropagation()"
                    >
                      <span class="cdk-visually-hidden">{{
                        member.checked
                          ? ('translations.global.ariaLabels.uncheck' | transloco: { name: member.firstName + ' ' + member.lastName })
                          : ('translations.global.ariaLabels.check' | transloco: { name: member.firstName + ' ' + member.lastName })
                      }}</span>
                    </mat-checkbox>
                  </td>
                }

                @if (isColumnEnabled('EXTERNAL_ID')) {
                  <td
                    class="external-id"
                    [headers]="'header-external-id'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.externalId"
                  >
                    <span class="extra-small text" matTooltip="{{ member.externalId }}" matTooltipClass="medium-tooltip">
                      {{ member.externalId }}
                    </span>
                  </td>
                }

                @if (isColumnEnabled('FIRST_NAME')) {
                  <td class="first-name" [headers]="'header-first-name'" [class.expanded]="expanded" [attr.aria-label]="member.firstName">
                    <div class="profile-image-with-first-name">
                      <img
                        class=""
                        role="img"
                        src="{{ member.imageUrl ? member.imageUrl : '../../../../../../../../assets/profile_image.png' }}"
                        alt="{{ member.firstName }} {{ member.lastName }}"
                      />
                      <span class="small text" matTooltip="{{ member.firstName }}" matTooltipClass="medium-tooltip">
                        {{ member.firstName }}
                      </span>
                    </div>
                  </td>
                }

                @if (isColumnEnabled('LAST_NAME')) {
                  <td
                    class="last-name sticky-columns-right-border"
                    [headers]="'header-last-name'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.lastName"
                  >
                    <div class="small text" matTooltipClass="medium-tooltip" matTooltip="{{ member.lastName }}">
                      {{ member.lastName }}
                    </div>
                  </td>
                }

                @if (isColumnEnabled('EMAIL')) {
                  <td [class.expanded]="expanded" [headers]="'header-email'">
                    <span
                      class="small"
                      [class.expanded]="expanded"
                      matTooltip="{{ member.email }}"
                      matTooltipClass="medium-tooltip"
                      [attr.aria-label]="member.email"
                    >
                      {{ member.email }}</span
                    >
                  </td>
                }

                @if (isColumnEnabled('ROLES') && !isEvent) {
                  <td class="role-cell" [headers]="'header-roles'" [class.expanded]="expanded">
                    <div #roleContent class="td-expandable-container">
                      @for (role of member.roles; track role) {
                        <span class="small expandable-text" [attr.aria-label]="role"> {{ role }}</span>
                      }

                      @if (checkOverflow(roleContent)) {
                        <button
                          class="show-more-btn"
                          [class.expanded]="expanded"
                          [class.is-hovered]="hoveredUserUid === member._id"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="$event.stopPropagation()"
                          [matMenuTriggerFor]="rolesExpandContent"
                        >
                          <span class="extra-small show-more-btn-content">{{
                            'translations.membersNew.list.table.showMore' | transloco
                          }}</span>
                        </button>
                      }
                    </div>
                    <mat-menu #rolesExpandContent="matMenu">
                      <div class="expanded-menu-content">
                        <span class="small">{{ showExpandedContent(member, 'ROLES') }}</span>
                      </div>
                    </mat-menu>
                  </td>
                }

                @if (isColumnEnabled('STATUS')) {
                  <td [headers]="'header-status'" [class.expanded]="expanded">
                    <div class="icon-text">
                      <svg
                        class="svg"
                        role="img"
                        aria-hidden="true"
                        [ngClass]="{
                          positive: getMemberCompletionStatus(member) === 'COMPLETED',
                          warn: getMemberCompletionStatus(member) === 'IN_PROGRESS',
                          negative: getMemberCompletionStatus(member) === 'NOT_STARTED',
                        }"
                      >
                        <use ogSvgUnify="assets/sprite/sprite.svg#ellipse_6"></use>
                      </svg>
                      @switch (getMemberCompletionStatus(member)) {
                        @case ('COMPLETED') {
                          <span class="small">{{ 'translations.membersNew.list.table.completed' | transloco }}</span>
                        }
                        @case ('IN_PROGRESS') {
                          <span class="small">{{ 'translations.membersNew.list.table.started' | transloco }}</span>
                        }
                        @case ('NOT_STARTED') {
                          <span class="small">{{ 'translations.membersNew.list.table.notStarted' | transloco }}</span>
                        }
                      }
                    </div>
                  </td>
                }

                @if (isColumnEnabled('ENROL') && (playlistHastTicketsRegistration$ | async)) {
                  <td [headers]="'header-enrol'" [class.expanded]="expanded">
                    <div [class.registered-cell]="member?.enrollment?.registeredOn">
                      <div class="registered-cell--date">{{ member?.enrollment?.registeredOn | dateFormat: 'D MMM yyyy HH:mm' }}</div>
                      <div class="icon-selectbox" [class.icon-selectbox--registered]="member?.enrollment?.registeredOn">
                        <svg
                          class="svg"
                          role="img"
                          aria-hidden="true"
                          [class.positive]="getEnrollmentField(member) === 'Registered'"
                          [class.negative]="getEnrollmentField(member) === 'Canceled'"
                        >
                          <use ogSvgUnify="assets/sprite/sprite.svg#ellipse_6"></use>
                        </svg>
                        <mat-select
                          class="selectbox small"
                          [attr.aria-label]="'translations.global.ariaLabels.willRegisteredSelectbox' | transloco"
                          [value]="getEnrollmentFieldNumber(member)"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="$event.stopPropagation()"
                          (selectionChange)="onEnrolSelect($event, member._id)"
                        >
                          <mat-option [value]="0">
                            <span>{{ 'translations.membersNew.list.table.registered' | transloco }}</span>
                          </mat-option>
                          <mat-option [value]="1">
                            <span>{{ 'translations.membersNew.list.table.notRegistered' | transloco }}</span>
                          </mat-option>
                        </mat-select>
                      </div>
                    </div>
                  </td>
                }

                @if (isColumnEnabled('REVIEW_STATUS')) {
                  <td [headers]="'header-review-status'" [attr.aria-label]="member.review" [class.expanded]="expanded">
                    @if (member.review?.status) {
                      <div class="review-status-container">
                        <div class="review-status-badge-container">
                          <span
                            class="review-status_badge"
                            [ngClass]="{
                              closed: member.review?.status.open === false,
                              needsReview: member.review?.status.open,
                            }"
                          >
                            {{ member.review?.status | learnerReviewStatus: 'text' | transloco }}
                          </span>
                        </div>

                        @if (canManageReviewsPrivileges$ | async) {
                          <div
                            class="manage-reviews-btn extra-small"
                            role="button"
                            [attr.aria-label]="'translations.global.ariaLabels.tapToOpenReviewsModal' | transloco"
                            (keydown.enter)="openManageReviewersModal(member.review._id, $event)"
                            (click)="openManageReviewersModal(member.review._id, $event)"
                          >
                            {{ 'translations.cards.review.button.reviewers' | transloco }}
                          </div>
                        }

                        @if ((userPlaylistSubmissionSummary$ | async).submissionMode === 'SINGLE') {
                          <div
                            class="manage-reviews-btn extra-small"
                            role="button"
                            [attr.aria-label]="'translations.global.ariaLabels.undoReview' | transloco"
                            (keydown.enter)="openUndoReviewModal(member.review._id, $event)"
                            (click)="openUndoReviewModal(member.review._id, $event)"
                          >
                            {{ 'translations.cards.review.button.undo' | transloco }}
                          </div>
                        }
                      </div>
                    }
                  </td>
                }

                @if (isColumnEnabled('STARTED')) {
                  <td
                    [headers]="'header-started'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.startedOn | dateFormat: 'D MMM yyyy'"
                  >
                    <span class="small">{{ member.startedOn | dateFormat: 'D MMM yyyy' }}</span>
                  </td>
                }

                @if (isColumnEnabled('COMPLETED')) {
                  <td
                    [headers]="'header-completed'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.completedOn | dateFormat: 'D MMM yyyy'"
                  >
                    <span class="small">{{ member.completedOn | dateFormat: 'D MMM yyyy' }}</span>
                  </td>
                }

                @if (isColumnEnabled('LAST_ACTIVE')) {
                  <td
                    [headers]="'header-last-active'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.lastActiveOn | dateFormat: 'D MMM yyyy'"
                  >
                    <span class="small">
                      {{ member.lastActiveOn | dateFormat: 'D MMM yyyy' }}
                    </span>
                  </td>
                }

                @if (isPlaylistPage) {
                  @for (card of member.cards; track card; let j = $index) {
                    <td [headers]="'header-completed'" [class.expanded]="expanded">
                      <div class="card-status">
                        @if (!card.underReview) {
                          @if (card.completed) {
                            <span class="completed-container">
                              <mat-icon aria-hidden="true" class="mat-icon completed">check</mat-icon>
                              <div class="extra-small completed-text">
                                {{ card.completedOn | dateFormat: 'D MMM yyyy HH:mm' }}
                              </div>
                            </span>
                          }
                          @if (!card.completed && card.startedOn) {
                            <span>
                              <mat-icon aria-hidden="true" class="mat-icon warn">loop</mat-icon>
                            </span>
                          }
                        }
                        @if (card.underReview) {
                          <span class="small" [attr.aria-label]="'translations.global.ariaLabels.review' | transloco">
                            {{ 'translations.global.label.review' | transloco }}</span
                          >
                        }
                      </div>
                    </td>
                  }
                }

                @if (isColumnEnabled('JOIN_DATE')) {
                  <td
                    [headers]="'header-join-date'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="member.createdAt | dateFormat: 'D MMM yyyy'"
                  >
                    <span class="small">{{ member.createdAt | dateFormat: 'D MMM yyyy' }}</span>
                  </td>
                }

                @if (isColumnEnabled('WILL_ATTEND')) {
                  <td [headers]="'header-will-attend'" [class.expanded]="expanded">
                    <div [class.registered-cell]="member?.event?.registeredOn">
                      <div class="registered-cell--date">{{ member?.event?.registeredOn | dateFormat: 'D MMM yyyy HH:mm' }}</div>
                      <div class="icon-selectbox" [class.icon-selectbox--registered]="member?.event?.registeredOn">
                        <svg
                          class="svg"
                          role="img"
                          aria-hidden="true"
                          [class.positive]="getMemberWillAttendField(member) === 'Yes'"
                          [class.negative]="getMemberWillAttendField(member) === 'No'"
                          [class.warn]="getMemberWillAttendField(member) === 'Waiting list'"
                        >
                          <use ogSvgUnify="assets/sprite/sprite.svg#ellipse_6"></use>
                        </svg>
                        <mat-select
                          class="selectbox small"
                          [attr.aria-label]="'translations.global.ariaLabels.willAttendSelectbox' | transloco"
                          [value]="getMemberWillAttendFieldNumber(member)"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="$event.stopPropagation()"
                          (selectionChange)="onWillAttendSelect($event, member._id)"
                        >
                          <mat-option [value]="0">
                            <span>{{ 'translations.membersNew.list.table.selectboxYes' | transloco }}</span>
                          </mat-option>
                          <mat-option [value]="1">
                            <span>{{ 'translations.membersNew.list.table.selectboxNo' | transloco }}</span>
                          </mat-option>
                          @if (isWaitingListEnabled) {
                            <mat-option [value]="2" [disabled]="isWaitingListOperationDisabled" [matTooltip]="disabledWaitingListText">
                              <span>{{ 'translations.membersNew.list.table.selectboxWaitingList' | transloco }}</span>
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </div>
                  </td>
                }

                @if (isColumnEnabled('RESPONSE_DATE')) {
                  <td
                    [headers]="'header-response-date'"
                    [class.expanded]="expanded"
                    [attr.aria-label]="getEventResponseDate(member) | dateFormat: 'D MMM yyyy'"
                  >
                    <span class="small">{{ getEventResponseDate(member) | dateFormat: 'D MMM yyyy' }}</span>
                  </td>
                }

                @if (isColumnEnabled('HAS_ATTENDED')) {
                  <td
                    [headers]="'header-has-attended'"
                    [class.expanded]="expanded"
                    class="small"
                    [attr.aria-label]="
                      hasMemberAttendedEvent(member)
                        ? ('translations.membersNew.list.table.selectboxYes' | transloco)
                        : ('translations.membersNew.list.table.selectboxNo' | transloco)
                    "
                  >
                    <div class="icon-selectbox">
                      <svg
                        class="svg"
                        role="img"
                        aria-hidden="true"
                        [class.positive]="hasMemberAttendedEvent(member)"
                        [class.negative]="!hasMemberAttendedEvent(member)"
                      >
                        <use ogSvgUnify="assets/sprite/sprite.svg#ellipse_6"></use>
                      </svg>
                      <mat-select
                        class="selectbox small"
                        [attr.aria-label]="'translations.global.ariaLabels.hasAttendedSelectbox' | transloco"
                        [value]="hasMemberAttendedEvent(member)"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="$event.stopPropagation()"
                        (selectionChange)="onHasAttendedEvent($event, member)"
                      >
                        <mat-option [value]="true">
                          {{ 'translations.membersNew.list.table.selectboxYes' | transloco }}
                        </mat-option>
                        <mat-option [value]="false">
                          {{ 'translations.membersNew.list.table.selectboxNo' | transloco }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </td>
                }

                @if (isColumnEnabled('CHECK_IN_METHOD')) {
                  <td [headers]="'header-check-in-method'" [class.expanded]="expanded">
                    @if (member.event?.checkInMethod === 'MANUAL') {
                      <span class="small" [attr.aria-label]="'translations.membersNew.list.table.checkInMethodManual' | transloco">
                        {{ 'translations.membersNew.list.table.checkInMethodManual' | transloco }}
                      </span>
                    }
                    @if (member.event?.checkInMethod === 'QR_CODE') {
                      <span class="small" [attr.aria-label]="'translations.membersNew.list.table.checkInMethodQrCode' | transloco">
                        {{ 'translations.membersNew.list.table.checkInMethodQrCode' | transloco }}
                      </span>
                    }
                    @if (member.event?.checkInMethod === 'IMPORT') {
                      <span class="small" [attr.aria-label]="'translations.membersNew.list.table.checkInMethodImport' | transloco">
                        {{ 'translations.membersNew.list.table.checkInMethodImport' | transloco }}
                      </span>
                    }
                  </td>
                }

                @if (isColumnEnabled('CHECK_IN_TIME')) {
                  <td [headers]="'header-check-in-time'" [class.expanded]="expanded">
                    @if (member.event?.checkInMethod) {
                      <span class="small">
                        {{ getMemberFormattedParticipationTime(member) }}
                      </span>
                    }
                  </td>
                }

                @if (isColumnEnabled('ROLES') && isEvent) {
                  <td class="role-cell" [headers]="'header-roles-in-event'" [class.expanded]="expanded">
                    <div #roleContent class="td-expandable-container">
                      @for (role of member.roles; track role) {
                        <span class="small expandable-text" [attr.aria-label]="role"> {{ role }}</span>
                      }

                      @if (checkOverflow(roleContent)) {
                        <button
                          class="show-more-btn"
                          [class.is-hovered]="hoveredUserUid === member._id"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="$event.stopPropagation()"
                          [matMenuTriggerFor]="rolesExpandContent"
                        >
                          <span class="extra-small show-more-btn-content">{{
                            'translations.membersNew.list.table.showMore' | transloco
                          }}</span>
                        </button>
                      }
                    </div>
                    <mat-menu #rolesExpandContent="matMenu">
                      <div class="expanded-menu-content">
                        <span class="small">{{ showExpandedContent(member, 'ROLES') }}</span>
                      </div>
                    </mat-menu>
                  </td>
                }

                @if (isColumnEnabled('GROUPS')) {
                  <td [headers]="'header-groups'" [class.expanded]="expanded">
                    <div #groupContent class="td-expandable-container">
                      @for (group of nonCourseGroups(member); track group.groupId) {
                        <span class="small expandable-text" [attr.aria-label]="group.title"> {{ group.title }}</span>
                      }
                      @if (checkOverflow(groupContent)) {
                        <button
                          class="show-more-btn"
                          [class.is-hovered]="hoveredUserUid === member._id"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="$event.stopPropagation()"
                          [matMenuTriggerFor]="groupsExpandContent"
                        >
                          <span class="extra-small show-more-btn-content">{{
                            'translations.membersNew.list.table.showMore' | transloco
                          }}</span>
                        </button>
                      }
                    </div>
                    <mat-menu #groupsExpandContent="matMenu">
                      <div class="expanded-menu-content">
                        <span class="small">{{ showExpandedContent(member, 'GROUPS') }}</span>
                      </div>
                    </mat-menu>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  } @else if (!isLoaderActive) {
    <div class="members-list__empty">
      <ptl-v3-empty-state
        size="m"
        [icon]="LucideUsers"
        [title]="'translations.membersNew.list.table.noUsersFound' | transloco"
        [description]="'translations.membersNew.list.table.noUsersFoundDescription' | transloco"
      ></ptl-v3-empty-state>
      @if (isEvent || (isPlaylistPage && (playlistHastTicketsRegistration$ | async))) {
        <div class="add-someone-manually-btn-empty-list-box">
          <ptl-admin-add-member
            [isPlaylistPage]="isPlaylistPage"
            [isCardPage]="isCardPage"
            [isEvent]="isEvent"
            [members]="members"
            (memberActionTriggered)="onMemberSelected($event)"
          ></ptl-admin-add-member>
        </div>
      }
    </div>
  }
  @if ((paginationLength || isEvent || (isPlaylistPage && (playlistHastTicketsRegistration$ | async))) && members?.length) {
    <div class="buttons-row f_buttons-row">
      @if (isEvent || (isPlaylistPage && (playlistHastTicketsRegistration$ | async))) {
        <div class="add-someone-manually-btn-cell" [class.expanded]="expanded">
          <ptl-admin-add-member
            [isPlaylistPage]="isPlaylistPage"
            [isCardPage]="isCardPage"
            [isEvent]="isEvent"
            [members]="members"
            (memberActionTriggered)="onMemberSelected($event)"
          ></ptl-admin-add-member>
        </div>
      }
      @if (paginationLength) {
        <td class="pagination-cell" [class.expanded]="expanded">
          <ptl-pagination-footer
            [totalItems]="membersTotalCount"
            [pageSize]="pageSize"
            [currentPage]="currentPage + 1"
            (pageChange)="onPageChangeEvent($event)"
            (pageSizeChange)="onSizeChange($event)"
          ></ptl-pagination-footer>
        </td>
      }
    </div>
  }
</div>
